import './styles.scss'

function Content(props) {
  const { className = null, children } = props
  return (
    <div className={`public-page__content__wrapper ${className}`}>
      <div className="public-page__content">{children}</div>
    </div>
  )
}

export default Content
